import './App.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="/cwbclub.svg" className="App-logo" alt="logo" />
        <p>Your coding club's platform is under process.</p>
        <a
          className="App-link"
          href="https://canwebe.tech"
          target="_blank"
          rel="noopener noreferrer"
        >
          Know about CanWeBe!
        </a>
      </header>
    </div>
  )
}

export default App
